import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import * as _ from 'lodash';
@Component({
    templateUrl: './multipleSelector.component.html',
    standalone: false
})
export class MultipleSelectorComponent implements OnInit {
  public selectorValues: any;
  public query = '';
  public search = false;

  constructor(public modal: ModalComponent, private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {}

  updateSelected(item: any): void {
    item.selected = !item.selected;
    this.cdRef.detectChanges();
  }

  public init(data: any) {
    this.selectorValues = data.values;
    if (data.search) {
      this.search = data.search;
    }
    this.processData();
  }

  public getData(): any {
    return this.selectorValues;
  }

  public hasProperty(item: any, property: string) {
    return item.hasOwnProperty(property);
  }

  processData() {
    _.forEach(this.selectorValues, (el) => {
      if (!el.search) {
        el.search = (query: string): boolean =>
          (el.label && el.label.toLowerCase().includes(query.toLowerCase())) ||
          (el.hasOwnProperty('toLowerCase') && el.toLowerCase().includes(query.toLowerCase()));
      }
    });
  }
}
